import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderHomeGallery() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@0.75': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    '@1.00': {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    '@1.50': {
                        slidesPerView: 5,
                        spaceBetween: 20,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >
                <SwiperSlide>
                    <div className="swiper-slide">
                        <div className="instagram-banner-items">
                            <Link to='/gallery'>
                                <div className="banner-image">
                                    <img src="assets/img/svp/gallery/1.jpg" alt="insta-img" />
                                </div>
                            </Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide">
                        <div className="instagram-banner-items">
                            <Link to='/gallery'>
                                <div className="banner-image">
                                    <img src="assets/img/svp/gallery/2.jpg" alt="insta-img" />
                                </div>
                            </Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide">
                        <div className="instagram-banner-items">
                            <Link to='/gallery'>
                                <div className="banner-image">
                                    <img src="assets/img/svp/gallery/3.jpg" alt="insta-img" />
                                </div>
                            </Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide">
                        <div className="instagram-banner-items">
                            <Link to='/gallery'>
                                <div className="banner-image">
                                    <img src="assets/img/svp/gallery/4.jpg" alt="insta-img" />
                                </div>
                            </Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide">
                        <div className="instagram-banner-items">
                            <Link to='/gallery'>
                                <div className="banner-image">
                                    <img src="assets/img/svp/gallery/5.jpg" alt="insta-img" />
                                </div>
                            </Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide">
                        <div className="instagram-banner-items">
                            <Link to='/gallery'>
                                <div className="banner-image">
                                    <img src="assets/img/svp/gallery/6.jpg" alt="insta-img" />
                                </div>
                            </Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide">
                        <div className="instagram-banner-items">
                            <Link to='/gallery'>
                                <div className="banner-image">
                                    <img src="assets/img/svp/gallery/7.jpg" alt="insta-img" />
                                </div>
                            </Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide">
                        <div className="instagram-banner-items">
                            <Link to='/gallery'>
                                <div className="banner-image">
                                    <img src="assets/img/svp/gallery/9.jpg" alt="insta-img" />
                                </div>
                            </Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide">
                        <div className="instagram-banner-items">
                            <Link to='/gallery'>
                                <div className="banner-image">
                                    <img src="assets/img/svp/gallery/10.jpg" alt="insta-img" />
                                </div>
                            </Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide">
                        <div className="instagram-banner-items">
                            <Link to='/gallery'>
                                <div className="banner-image">
                                    <img src="assets/img/svp/gallery/11.jpg" alt="insta-img" />
                                </div>
                            </Link>
                        </div>
                    </div>
                </SwiperSlide>
               




            </Swiper>
        </>
    );
}
